module.exports = __webpack_public_path__ + "static/media/structure.5cd68f87.ogg";